export { default } from "./SCHOOL_REGISTRATION_QUERY_KEYS";
